.card,
.cardDisabled {
  display: flex;
  flex-direction: column;
  padding: 12px;
  border: 1px solid var(--tuna-palette-divider);
  border-radius: 8px;
  background: var(--tuna-palette-background-paper);
}

.cardDisabled {
  opacity: 0.5;
}

.heading {
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.endingChord {
  font-size: 1.1rem;
  margin: 0 0 4px 0;
}

.tagLabel {
  font-size: 0.85rem;
  color: var(--tuna-palette-text-secondary);
  margin: 0 0 8px 0;
}

.actions {
  display: flex;
  gap: 8px;
}

.suppression {
  font-size: 0.85rem;
  color: var(--tuna-palette-text-secondary);
  margin: 0;
}
